module.exports = __webpack_public_path__ + "img/calendar.258e578e.svg";